module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bioField"
  }, [_c('mu-text-field', {
    attrs: {
      "hintText": "Describe yourself",
      "errorText": _vm.error,
      "errorColor": "red",
      "multiLine": "",
      "fullWidth": "",
      "rows": 3,
      "rowsMax": 6,
      "maxLength": _vm.max
    },
    on: {
      "textOverflow": _vm.handleOverflow
    },
    model: {
      value: (_vm.bio),
      callback: function($$v) {
        _vm.bio = $$v
      },
      expression: "bio"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bio-buttons"
  }, [_c('mu-flat-button', {
    attrs: {
      "label": "Cancel"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeBio.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "label": "Save",
      "primary": "",
      "disabled": _vm.isBioError
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveBio.apply(null, arguments)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-573915f9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/AddProfileBio/AddProfileBio.vue
// module id = 3182
// module chunks = 1